type LogArgs = unknown[];

const isDev = Boolean(import.meta.env?.DEV);

export const logger = {
  debug: (...args: LogArgs) => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },
  warn: (...args: LogArgs) => {
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  error: (...args: LogArgs) => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
} as const;


